var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9804 10.7454C21.9804 1.55078 21.2619 1.1875 10.6836 1.1875C1.02347 1.1875 1.62218 3.48831 1.02344 10.7454C1.02341 21.0471 1.62218 22.137 10.6836 22.137C21.2619 22.137 21.9804 22.8354 21.9804 10.7454Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.16531
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1858 4.52119C20.1858 3.58026 19.6979 2.99219 18.4172 2.99219C17.5605 3.05351 17.0755 3.40384 16.8926 4.52119C16.8926 5.63854 17.4897 6.21937 18.4172 6.28542C19.6979 6.28542 20.1858 5.57973 20.1858 4.52119Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7949 10.8894C17.7949 7.12574 15.932 4.77344 11.0421 4.77344C7.77109 5.01873 5.91926 6.42005 5.2207 10.8894C5.22071 15.3588 7.50057 17.6822 11.0421 17.9464C15.932 17.9464 17.7949 15.1236 17.7949 10.8894Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.16531
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5424 11.2123C15.5424 8.81723 14.3448 7.32031 11.2013 7.32031C9.09852 7.47641 7.90806 8.36816 7.45898 11.2123C7.45899 14.0565 8.92462 15.535 11.2013 15.7031C14.3448 15.7031 15.5424 13.9068 15.5424 11.2123Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 1.16531
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.3eb5367b35c88ad9fff65d33ee714bdf.svg";
export { ForwardRef as ReactComponent };